import { useEffect, useState } from 'react';
import request from '../../../../lib/request';
import Tabs from './tab';
import ChallengeList from './list';

const TAB = {
  HISTORY: 'HISTORY',
  CURRENT: 'CURRENT',
  SCHEDULED: 'SCHEDULED',
};

const Challenge = ({ user }) => {
  const [tab, setTab] = useState(TAB.CURRENT);

  useEffect(() => {
    updateChallengeStatus();
  }, []);

  const handleTab = (t) => () => {
    setTab(t);
  };

  const updateChallengeStatus = async () => {
    try {
      await request.put('/user/challenge/outdated');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Tabs
        currentTab={tab}
        list={[
          { key: TAB.HISTORY, name: 'History' },
          { key: TAB.CURRENT, name: 'Current' },
          { key: TAB.SCHEDULED, name: 'Scheduled' },
        ]}
        handleTab={handleTab}
      />
      <ChallengeList status={tab} />
    </div>
  );
};

export default Challenge;
